import React from 'react'
import { HeaderBlock } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'

export default function NoDataNotice({ bgOpacity = 0.5 }) {
  const [t] = useTranslation()
  const styling = css`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, ${bgOpacity});
    margin-top: 60px;
  `
  return (
    <div css={styling}>
      <HeaderBlock heading={t('aam.no.data.for.year', "We don't have data for the selected year")} size="md" centered />
    </div>
  )
}
